import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useServices from 'Hooks/useServices';

import {
	generalSelectors,
	walletPaymentTypes,
	walletPaymentActions,
	walletPaymentSelectors,
} from 'Ducks';
import WalletTransactionCard from 'Components/WalletPayment/WalletTransactionCard';
import Skeleton from 'Components/Globals/Skeleton/loadable';
import Loading from 'Components/Globals/Loading/loadable';
import NotFound from 'Components/WalletPayment/NotFound';
import { useObserver } from 'Helpers';

import styles from './styles.module.scss';

function WalletTransaction() {
	const dispatch = useDispatch();
	const { businessId } = useServices();

	const [page, setPage] = useState(1);
	const transactionList = useSelector(
		walletPaymentSelectors.walletTransactionList
	);
	const totalPages = useSelector(walletPaymentSelectors.totalTransactionList);
	const PER_PAGE = 10;
	const [hasMore, setHasMore] = useState(totalPages > page * PER_PAGE);
	const isLoadingList = useSelector((state) =>
		generalSelectors.selectApiLoadingStatus(
			state,
			walletPaymentTypes.WALLET_TRANSACTION.REQUEST
		)
	);
	const onFetchWalletList = (page) => {
		dispatch(
			walletPaymentActions.walletTransactionRequest({
				business_id: businessId,
				page,
				per_page: PER_PAGE,
			})
		);
	};
	const onLoadMore = () => {
		if (!isLoadingList) {
			onFetchWalletList(page + 1);
			setPage((perv) => perv + 1);
		}
	};

	const { observableElement: loadingRef } = useObserver({
		callback: onLoadMore,
		options: { threshold: 0.5 },
	});

	useEffect(() => {
		onFetchWalletList(page);
		return () => {
			dispatch(walletPaymentActions.walletTransactionClear());
		};
	}, []);

	useEffect(() => {
		setHasMore(totalPages > page * PER_PAGE);
	}, [totalPages, page]);

	return (
		<>
			{isLoadingList && !transactionList?.length ? (
				<div className={styles.skeleton}>
					{Array.from(Array(10), (_, i) => (
						<>
							<div
								className={`mh-16 ph-16 pv-6 ${styles.skeleton__card}`}
								key={i}
							>
								<div className={styles.inline}>
									<Skeleton className={styles.skeleton__card__title} />
									<Skeleton className={styles.skeleton__card__title} />
								</div>
								<Skeleton className={styles.skeleton__card__date} />
							</div>
							<div className={styles.skeleton__card__border}></div>
						</>
					))}
				</div>
			) : transactionList && transactionList.length > 0 ? (
				<div className={styles.wrapper}>
					<WalletTransactionCard walletTransactionList={transactionList} />
					{hasMore && (
						<div
							ref={loadingRef}
							className={`p-16 ${styles.wrapper__infinity_scroll_loading}`}
						>
							<Loading size='sm' />
						</div>
					)}
				</div>
			) : (
				<NotFound />
			)}
		</>
	);
}

export default WalletTransaction;
